<template>
  <el-dialog
    title="操作记录"
    width="640px"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
  >
    <el-table v-loading="loading" :data="list" style="width:100%" border>
      <el-table-column label="操作动作" width="160" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.type === 1">增加考试次数</span>
          <span v-else-if="row.type === 2">减少考试次数</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="考试次数" width="100" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.num || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作时间" min-width="158" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.insertDate || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作人" min-width="120" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.insertName || '--' }}</span>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { numOperateRecordLisr } from "@/api/product/base"

export default {
  name: 'MangeExamLog',

  data () {
    return {
      dialogVisible: false,
      loading: false,
      list: []
    }
  },
  methods: {
    init (id) {
      this.getOrderListPage(id)
      this.dialogVisible = true
    },
    getOrderListPage(id) {
      this.loading = true
      numOperateRecordLisr({ id }).then(({ code, data }) => {
        if (code === 0) {
          this.list = data
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleClose () {
      this.list = []
      this.dialogVisible = false
    }
  }
}
</script>

<style>

</style>
